import { Button, DataSource, Layout, LayoutHeader, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutUserList extends Layout {
    buttonAddDockOp: Button;
    buttonLock: Button;
    buttonRevoke: Button;
    buttonRevokeAll: Button;
    buttonToggleActive: Button;
    buttonUnlock: Button;
    layoutheaderUserList: LayoutHeader;
    sourceUsers: DataSource;
    switchActive: Switch;
    tableSearch: Table;
}
